/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {
		
			jQuery('li.nav-item').hover(function() {
			    jQuery(this).find('.dropdown-menu').addClass('show');
			  }, function() {
			    jQuery(this).find('.dropdown-menu').removeClass('show');
			});

			$('.owl-loghi').owlCarousel({
			loop:false,
      center:false,
	    margin:30,
	    nav:true,
				responsive:{
	        0:{
	            items:1
	        },
	        600:{
	            items:3
	        },
	        1000:{
	            items:4
	        }
	    },
				navText : ['<span class="glyphicon glyphicon-chevron-left" style="top: 11px;color:grey;"></span>','<span class="glyphicon glyphicon-chevron-right" style="top: 11px;color:grey;"></span>'],
			});

		
	  

    $('body').on('click', '.invia-contatto', function() {
      var validator = $('#form-contatti').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        onclick: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nominativo: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          telefono: {
            required: true
          },
          check_privacy: {
            required: true
          },
        },
        messages: {
          nominativo: {
            required: setup.texts.testi['inserire-nome']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          check_privacy: {
            required: setup.texts.testi['check-privacy']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.messaggio = $('#messaggio').val();
      arr.captcha = $('#captcha').val();
      arr.check_privacy = $('#check_privacy').is(':checked');
      arr.check_commercial = $('#check_commercial').is(':checked');

      arr.id_pagina = $('#idpagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
               'event': 'Contact',
               'formLocation': $('#pagina').val()
               });
              
              $('#email').val('');
              $('#nominativo').val('');
              $('#privacy').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');
              
            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });


    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };



  });

}(jQuery));
